import React from 'react';

import { ProjectWithRole } from '@neptune/shared/core-project-domain';
import { Layout } from '@neptune/shared/venus-ui';
import { ProjectMemberListContainer } from '@neptune/user-management-feature';

type PeopleProps = {
  project: ProjectWithRole;
};

export const People = ({ project }: PeopleProps) => (
  <Layout.Column>
    <ProjectMemberListContainer project={project} />
  </Layout.Column>
);
